import React from 'react';

import _ from 'lodash';

import FieldGroup from '../../Fields/FieldGroup';
import Field from '../../Fields/Field';
import InputTextField from '../../Fields/InputTextField';
import SurveyQuestionTable from '../../Fields/SurveyQuestionTable';

import SurveyQuestion from '../../../Entities/SurveyQuestion';


class BillingProfilePurchasePanel extends React.Component {
  _onSurveyQuestionChange(type) {
    return (ident, value) => {
      const surveyQuestions = _.cloneDeep(this.props.billingProfile.fields.survey_questions);

      // Define ident for new survey questions being added
      if (ident === null) ident = surveyQuestions[type].value.length;

      if (value === null) {
        // Removing survey question
        surveyQuestions[type].value.splice(ident, 1);
      }
      else {
        surveyQuestions[type].value[ident] = value;
      }

      this._onInputChange('survey_questions')(surveyQuestions);
    };
  }


  _onInputChange(inputId) {
    return value => {
      switch (inputId) {
        default:
      }

      this.props.onBillingProfileInputChange(inputId, value);
    };
  }


  handleAddPurchaseSurveyQuestionClick = () => {
    this._onSurveyQuestionChange('purchase')(null, new SurveyQuestion('PURCHASE'));
  }


  render() {
    const {
      billingProfile,
      newMode,
      editMode
    } = this.props;

    const purchaseSurveyQuestionTableRows = billingProfile.fields.survey_questions.purchase.value.map((surveyQuestion, index) => {
      return { ident: index, data: surveyQuestion };
    });

    return (
      <div>
        <FieldGroup>
          <Field label="Next Steps After Sign Up"
            id="parkchirp--billing-profile--next-steps"
            layout="stacked">
            <InputTextField inputId="parkchirp--billing-profile--next-steps"
              value={billingProfile.fields.next_steps.value}
              editMode={(newMode || editMode)}
              onChange={this._onInputChange('next_steps')}
              multiLine={true}
            />
          </Field>
        </FieldGroup>
        <FieldGroup label="Survey Questions">
          <Field>
            <SurveyQuestionTable inputId="parkchirp--billing-profile--purchase-survey-questions"
              surveyQuestionRows={purchaseSurveyQuestionTableRows}
              editMode={(newMode || editMode)}
              onSurveyQuestionChange={this._onSurveyQuestionChange('purchase')}
            />
            {(newMode || editMode) &&
              <button type="button"
                onClick={this.handleAddPurchaseSurveyQuestionClick}>
                Add Survey Question
              </button>
            }
          </Field>
        </FieldGroup>
      </div>
    );
  }
}
export default BillingProfilePurchasePanel;
